import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Leaflet's default marker icon references image paths that don't survive a webpack
// bundle (CRA/react-scripts) - mutating L.Icon.Default.prototype (the usual fix
// shown in most tutorials) doesn't reliably take effect under webpack 5's ESM/CJS
// interop for this package, so instead we build explicit L.Icon instances and pass
// one to every Marker (never leave the `icon` prop undefined).
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const TIER_COLOR = {
  gold: '#facc15',
  silver: '#94a3b8',
  bronze: '#EB9868',
};

const ICON_BASE = {
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
};

const defaultIcon = new L.Icon(ICON_BASE);
const goldIcon = new L.Icon({ ...ICON_BASE, className: 'wheely-marker-gold' });

// UK-wide default view (roughly centred, zoomed to show the whole country).
const UK_CENTER = [54.5, -3.5];
const UK_DEFAULT_ZOOM = 6;

const DriversMap = ({ drivers = [] }) => {
  const located = drivers.filter(
    (d) => typeof d.latitude === 'number' && typeof d.longitude === 'number'
  );

  return (
    <div className="rounded-lg overflow-hidden" style={{ height: 420 }}>
      <MapContainer
        center={UK_CENTER}
        zoom={UK_DEFAULT_ZOOM}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {located.map((driver) => (
          <Marker
            key={driver.id}
            position={[driver.latitude, driver.longitude]}
            icon={driver.membership_tier === 'gold' ? goldIcon : defaultIcon}
          >
            <Popup>
              <div style={{ minWidth: 140 }}>
                <p style={{ fontWeight: 700, marginBottom: 2 }}>{driver.name}</p>
                <p style={{ margin: 0 }}>
                  <span
                    style={{
                      display: 'inline-block',
                      padding: '1px 6px',
                      borderRadius: 4,
                      fontSize: 11,
                      color: '#1f2937',
                      background: TIER_COLOR[driver.membership_tier] || '#d1d5db',
                    }}
                  >
                    {driver.membership_tier || 'none'}
                  </span>
                </p>
                <p style={{ margin: '4px 0 0', fontSize: 12 }}>
                  ⭐ {driver.rating?.toFixed(1)} · {driver.total_jobs} jobs
                </p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      {drivers.length > 0 && located.length < drivers.length && (
        <p className="text-xs text-gray-400 mt-2">
          {drivers.length - located.length} online driver{drivers.length - located.length > 1 ? 's' : ''} without a reported location yet.
        </p>
      )}
    </div>
  );
};

export default DriversMap;
